<template>
    <v-tooltip 
        :right="right"
        :left="left"
        :top="top"
        :bottom="bottom"
        :color="tooltipColor"
    >
        <template v-slot:activator="{ on, attrs }">
            <div
                v-bind="attrs"
                v-on="on"
                @click="clickedIcon"
            >
                <slot name="icon" :color="iconColor" :icon="icon">
                    <v-icon
                        :color="iconColor"
                    >
                        {{ icon }}
                    </v-icon>
                </slot>
            </div>
        </template>
        <slot>
        </slot>
    </v-tooltip>
</template>

<script>
export default {
    name:"UiIconWithTooltip",
    props:{
        icon: {
            type: String,
            default: 'mdi-at'
        },
        iconColor: {
            type: String,
            default: ''
        },
        tooltipColor:{
            type: String,
            default: 'primary'
        },
        left: {
            type: Boolean,
            default: false
        },
        right: {
            type: Boolean,
            default: false
        },
        top: {
            type: Boolean,
            default: false
        },
        bottom: {
            type: Boolean,
            default: false
        },
    },
    methods:{
        clickedIcon: function(){
            this.$emit('click');
        }
    }
}
</script>
